module.exports = __webpack_public_path__ + "static/img/GL.1c40c653.svg";